import { Route, Routes } from 'react-router-dom';
import { NotFound, Token } from '@pages';
import Protected from '@components/Protected';

function RoutesToken() {
  return (
    <Protected>
      <Routes>
        <Route index element={<Token />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Protected>
  );
}
export default RoutesToken;
